import { useEffect, DependencyList } from 'react';

export const useDebounceEffect = (
  fn: () => void,
  waitTime: number,
  deps: DependencyList = []
): void => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      fn();
    }, waitTime);

    return () => {
      clearTimeout(timeout);
    };
  }, deps);
};
